export const TRANSACTION_SEARCH_API_VERSION = "04.09.01";

// export const TRANSACTION_SEARCH_ENDPOINT = "/report/search-transaction";
export const TRANSACTION_SEARCH_ENDPOINT = "/search-transaction";

export const TRANSACTION_SEARCH_MAX_RETRIES = 3;

export const TRANSACTION_SEARCH_RETRY_DELAY_MS = 2000;
